import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  // {
    
  //   path: '/jump',
  //   name: 'jump',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "jump" */ '../views/JumpView.vue')
  // },
  {
    path: '/brandAuth',
    name: 'brandAuth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jump" */ '../views/BrandAuth.vue')
    
  },
  {
    path: '/brandAuth_a3',
    name: 'brandAuth_a3',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jump" */ '../views/BrandAuth_a3.vue')
  },
  {
    
    path: '/brandAuth_a1',
    name: 'brandAuth_a1',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jump" */ '../views/BrandAuth_a1.vue')
  },
  {
    
    path: '/verifyCode',
    name: 'verifyCode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jump" */ '../views/VerifyCode.vue')
  },
  {
    
    path: '/ODM',
    name: 'ODM',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jump" */ '../views/ODM.vue')
  },
  {
    path: '/CutePet',
    name: 'CutePet',
    component: () => import(/* webpackChunkName: "jump" */ '../views/CutePet.vue')
  },
  {
    path: '/ODMJump',
    name: 'ODMJump',
    component: () => import(/* webpackChunkName: "jump" */ '../views/ODMJump.vue')
  },
  {
    path: '/NewRetail',
    name: 'NewRetail',
    component: () => import(/* webpackChunkName: "jump" */ '../views/NewRetail.vue')
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import(/* webpackChunkName: "pdf" */ '../views/PdfView.vue')
  }

]

const router = new VueRouter({
  routes
})

export default router
